// extracted by mini-css-extract-plugin
export default {"Page":"Favorite_Page__WkF0N","List":"Favorite_List__zdkhn","SectionTitle":"Favorite_SectionTitle__Y0mzd","Loader":"Favorite_Loader__glq0P"};